<div class="buttons-container">
    <app-generic-button
        (buttonClick)="meanOfPayment = meanOfPaymentEnum.BANCONTACT"
        [classes]="'btn btn--ternary post-btn' + (meanOfPayment === meanOfPaymentEnum.BANCONTACT ? ' -active' : '')"
        [inputText]="'SHOP.SHARED.STRIPE.BANCONTACT'"
    >
    </app-generic-button>
    <app-generic-button
        (buttonClick)="meanOfPayment = meanOfPaymentEnum.CREDIT_CARD"
        [classes]="'btn btn--ternary post-btn' + (meanOfPayment === meanOfPaymentEnum.CREDIT_CARD ? ' -active' : '')"
        [inputText]="'SHOP.SHARED.STRIPE.CREDIT_CARD'"
    >
    </app-generic-button>
</div>

<form
    [formGroup]="reloadForm"
    *ngIf="(!stripeConfirmation || stripeConfirmation === stripeStatusEnum.ERROR) && !isInTransaction && !isLoading"
>
    <div class="form-control stripe">
        <label>{{ 'SHOP.WALLET.RELOAD.AMOUNT-LABEL' | translate }}*</label>
        <app-basic-input
            [formControlName]="'amount'"
            [inputConfig]="{
                placeholder: '10,00',
                inputId: 'amount',
                type: basicInputTypeEnum.NUMBER
            }"
            [isValid]="reloadAmount.valid"
        >
            <app-form-errors *ngIf="reloadAmount.touched" [errors]="reloadAmount.errors"></app-form-errors>
        </app-basic-input>
    </div>
</form>

<app-stripe-card-form
    *ngIf="stripe && meanOfPayment === meanOfPaymentEnum.CREDIT_CARD"
    [stripe]="stripe"
    (launchPayment)="startPayment()"
    [hidden]="isInTransaction || isLoading"
    [amountControl]="reloadAmount"
></app-stripe-card-form>

<div *ngIf="meanOfPayment === meanOfPaymentEnum.BANCONTACT">
    <app-generic-button
        [classes]="'btn btn--primary'"
        [disabled]="reloadAmount.invalid"
        [inputText]="'SHOP.SHARED.STRIPE.BUTTON_FORM'"
        (buttonClick)="payBancontact()"
    ></app-generic-button>
</div>

<div class="stripe__waiting-confirm" *ngIf="isInTransaction || isLoading">
    <p>{{ 'SHOP.SHARED.STRIPE.WAITING_CONFIRM' | translate }}</p>
    <app-mini-loader></app-mini-loader>
</div>
<div class="stripe__confirm-success" *ngIf="stripeConfirmation === stripeStatusEnum.SUCCESS">
    <p>{{ 'SHOP.SHARED.STRIPE.CONFIRM_SUCCESS' | translate }}</p>
</div>
<div class="stripe__confirm-error" *ngIf="stripeConfirmation === stripeStatusEnum.ERROR">
    <p>{{ 'SHOP.SHARED.STRIPE.CONFIRM_ERROR' | translate }} {{ paymentError$ | async }}</p>
</div>
